import { FC } from "react";
import { getScoreColorClass } from "@src/utils/scoreColourClass";

interface Answer {
  intValue?: number | null;
  textValue?: string | null;
}

interface AnswerCellProps {
  answers?: Answer[] | null;
  emptyPlaceholder?: string;
}

const AnswerCell: FC<AnswerCellProps> = ({
  answers,
  emptyPlaceholder = "'-'",
}) => {
  if (!answers?.[0]) {
    return (
      <span className={`text-sm ${getScoreColorClass(0)}`}>
        {emptyPlaceholder}
      </span>
    );
  }

  return (
    <>
      {answers.map((answer) => (
        <p
          key={answer.textValue}
          className={`text-sm ${getScoreColorClass(answer.intValue ?? 0)}`}
        >
          {answer.textValue}
        </p>
      ))}
    </>
  );
};

export default AnswerCell;
